import { render, staticRenderFns } from "./supplierResourceManageView.vue?vue&type=template&id=ce70f95c&scoped=true"
import script from "./supplierResourceManageView.vue?vue&type=script&lang=js"
export * from "./supplierResourceManageView.vue?vue&type=script&lang=js"
import style0 from "./supplierResourceManageView.vue?vue&type=style&index=0&id=ce70f95c&lang=scss&scoped=true"
import style1 from "./supplierResourceManageView.vue?vue&type=style&index=1&id=ce70f95c&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce70f95c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce70f95c')) {
      api.createRecord('ce70f95c', component.options)
    } else {
      api.reload('ce70f95c', component.options)
    }
    module.hot.accept("./supplierResourceManageView.vue?vue&type=template&id=ce70f95c&scoped=true", function () {
      api.rerender('ce70f95c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/supplierManage/supplierResourceManageView.vue"
export default component.exports